export enum HearingFilePlatform {
  VideoConference = 0,
  Local = 1,
  Mobile = 2,
  OtherSource = 5,
}

export const isExternalSourcePlatform = (platform?: number | null): boolean =>
  platform === HearingFilePlatform.OtherSource;
